import script from "./firmInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./firmInfo.vue?vue&type=script&setup=true&lang=js"

import "./firmInfo.vue?vue&type=style&index=0&id=70ade9ca&lang=scss"
import "./firmInfo.vue?vue&type=style&index=1&id=70ade9ca&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ade9ca"]])

export default __exports__